module.exports = __webpack_public_path__ + "protect.4823626c.png";